import { HostListener, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ConfirmationService } from '../services/confirmation.service';
import { DirtinessService } from '../services/dirtiness.service';

@Injectable({
  providedIn: 'root'
})
export class DirtinessGuard  {
  isDirty: boolean = false;
  constructor(
    private _dirtnessService: DirtinessService,
    private _confirmationService: ConfirmationService
  ) {
    this._dirtnessService
      .dirtinessChanges()
      .subscribe(isDirty => {
        this.isDirty = isDirty;
      })
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }
  @HostListener('window:beforeunload')
  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    let leaving: boolean = true;
    if (this.isDirty) {
      return this._confirmationService
        .confirmLeavingPage(
          "Unsaved changes", 
          "You have unsaved changes. Do you want to leave this page?");
    }

    return leaving;
  }

}
